import React from 'react';
import PropTypes from 'prop-types';
import './AppDownloadModal.scss';

class AppDownloadModal extends React.Component {
    render() {
        const { showModal, setShowModal } = this.props;

        if (!showModal) return null;

        return (
            <div className="app-download-overlay">
                <div className="app-download-modal">
                    <button className="modal-close-button" onClick={() => setShowModal(false)}>×</button>
                    <img
                        className="modal-image"
                        src="/img/download-app-hero-img.png"
                        alt="Download App"
                    />
                    <div className="modal-content">
                        <h2 className="modal-title">
                            Get The Best Shyft Experience with the Mobile App
                        </h2>
                        <p className="modal-description">
                            Shyft is built for mobile, but not optimized for mobile browsers. When using Shyft on your phone, download the app for a better way to manage shifts on the go.
                        </p>
                        <div className="modal-buttons">
                            <a
                                href="https://apps.apple.com/us/app/shyft-shift-swap-schedule/id730422337"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img src="/img/app-store-badge.png" alt="Download on the App Store" />
                            </a>
                            <a
                                href="https://play.google.com/store/apps/details?id=com.coffeeenterprise"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img src="/img/google-play-badge.png" alt="Get it on Google Play" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

AppDownloadModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    setShowModal: PropTypes.func.isRequired,
};

export default AppDownloadModal;
